import { ginRummyDescriptor } from '@cardforest/games/games/gin-rummy/descriptor.js';
import { CardVignette, MiniPlayingCard, SuitGlyph } from '../discovery/cards.js';
import type { GameDiscoveryPresentation } from '../discovery/types.js';

export const ginRummyDiscoveryPresentation = {
  gameId: ginRummyDescriptor.gameId,
  Icon: ({ className }) => <SuitGlyph suit="diamonds" className={className} />,
  Thumbnail: () => (
    <CardVignette>
      <MiniPlayingCard
        rank="7"
        suit="clubs"
        showBottomPip={false}
        className="absolute -rotate-10 -translate-x-3.5 translate-y-0.5"
      />
      <MiniPlayingCard rank="7" suit="diamonds" showBottomPip={false} className="absolute z-10 -translate-y-0.5" />
      <MiniPlayingCard rank="7" suit="spades" className="absolute z-20 rotate-10 translate-x-3.5 translate-y-0.5" />
    </CardVignette>
  ),
} satisfies GameDiscoveryPresentation;
